import {ComponentType} from 'react';
import FabContact from '../../../assets/icons/FabContact';
import FabNavigate from '../../../assets/icons/FabNavigate';
import FabEventPage from '../../../assets/icons/FabEventPage';
import FabCancelTicket from '../../../assets/icons/FabCancelTicket';
import FabWallet from '../../../assets/icons/FabWallet';
import {TEticketData} from '../../../redux/eTicket/eTicket.type';

type IconComp = ComponentType<{size?: number; fill?: string; className?: string}>;

export interface FabMenuItem {
    key: string;
    label: string;
    Icon: IconComp;
    danger?: boolean;
    onClick?: () => void;
}

interface GetFabMenuParams {
    data: TEticketData;
    t: (key: string) => string;
    openContact: () => void;
    openNavigate: () => void;
    openWallet?: () => void;
}

const openUrl = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');
export const cancelTicket = (cancel: string, t: (key: string) => string) => {
    if(cancel)
        openUrl(cancel);
    else
        alert(t('actionCancelTicketWarning'));
};

export function getFabMenu({data, t, openContact, openNavigate, openWallet}: GetFabMenuParams): FabMenuItem[] {
    const eventPage = data.links?.eventPage;
    const cancelAllowed = data.cancelAllowed;
    const cancel = data.links?.cancel;
    const hasContact = Boolean(data.producer?.phone || data.producer?.email || data.order?.phone || data.order?.email);
    const hasNavigate = Boolean(data.event?.address || data.event?.location);

    const items: FabMenuItem[] = [];
    if(cancelAllowed)
        items.push({key: 'cancelTicket', label: t('actionCancelTicket'), Icon: FabCancelTicket, danger: true, onClick: () =>  cancelTicket(cancel, t)});
    if(hasContact)
        items.push({key: 'contact', label: t('actionContact'), Icon: FabContact, onClick: openContact});
    if(openWallet)
        items.push({key: 'addToWallet', label: t('actionAddToWallet'), Icon: FabWallet, onClick: openWallet});
    if(eventPage)
        items.push({key: 'eventPage', label: t('actionEventPage'), Icon: FabEventPage, onClick: () => openUrl(eventPage)});
    if(hasNavigate)
        items.push({key: 'navigate', label: t('navigate'), Icon: FabNavigate, onClick: openNavigate});
    return items;
}
